/*
 * API Endpoints to backend services.
 * API is stateless (apart from supporting the languageTag),
 *
 * API calls return a value with the actual JSON payload,
 * in case of error it will throw an Error.
 *
 */
// Service Gateway URL
// By default it is configured for local development.
import * as auth from '@ndvr/auth-api';
import * as billing from '@ndvr/billing-api';
import * as clientGateway from '@ndvr/client-gateway-api';
import * as cms from '@ndvr/cms-api';
import * as customer from '@ndvr/customer-api';
import * as marketData from '@ndvr/market-data-api';
import * as ncrm from '@ndvr/ncrm-api';
import * as portfolio from '@ndvr/portfolio-api';
import * as reporting from '@ndvr/reporting-api';

import { API_ROOT } from 'env';
import { HttpClient } from 'utils';

import { Configuration, InvestmentRequestApi } from './cip/_openapi/portfolio-optimizer';
import { defaultApiConfig } from './cip/api/defaultApiConfig';

const authUrl = `${API_ROOT}/auth`;
export const AuthApi = ({ hideError = false }: { hideError?: boolean } = {}): auth.RestApplicationClient =>
    new auth.RestApplicationClient(new HttpClient(authUrl, hideError));

export const billingUrl = `${API_ROOT}/billing`;
export const BillingApi = ({ hideError = false }: { hideError?: boolean } = {}): billing.RestApplicationClient =>
    new billing.RestApplicationClient(new HttpClient(billingUrl, hideError));

const clientGatewayUrl = `${API_ROOT}/client-gateway`;
export const ClientGatewayApi = ({
    hideError = false,
}: { hideError?: boolean } = {}): clientGateway.RestApplicationClient =>
    new clientGateway.RestApplicationClient(new HttpClient(clientGatewayUrl, hideError));

const cmsUrl = `${API_ROOT}/cms`;
export const CmsApi = ({ hideError = false }: { hideError?: boolean } = {}): cms.RestApplicationClient =>
    new cms.RestApplicationClient(new HttpClient(cmsUrl, hideError));

const customerUrl = `${API_ROOT}/customer`;
export const CustomerApi = ({ hideError = false }: { hideError?: boolean } = {}): customer.RestApplicationClient =>
    new customer.RestApplicationClient(new HttpClient(customerUrl, hideError));

const ncrmUrl = `${API_ROOT}/ncrm`;
export const NcrmApi = ({ hideError = false }: { hideError?: boolean } = {}): ncrm.RestApplicationClient =>
    new ncrm.RestApplicationClient(new HttpClient(ncrmUrl, hideError));

const marketDataUrl = `${API_ROOT}/market-data`;
export const MarketDataApi = ({ hideError = false }: { hideError?: boolean } = {}): marketData.RestApplicationClient =>
    new marketData.RestApplicationClient(new HttpClient(marketDataUrl, hideError));

const portfolioUrl = `${API_ROOT}/portfolio`;
export const PortfolioApi = ({ hideError = false }: { hideError?: boolean } = {}): portfolio.RestApplicationClient =>
    new portfolio.RestApplicationClient(new HttpClient(portfolioUrl, hideError));

const reportingUrl = `${API_ROOT}/reporting`;
export const ReportingApi = ({ hideError = false }: { hideError?: boolean } = {}): reporting.RestApplicationClient =>
    new reporting.RestApplicationClient(new HttpClient(reportingUrl, hideError));

export const portfolioOptimizerClient = {
    investmentRequestApi: new InvestmentRequestApi(new Configuration(defaultApiConfig)),
} as const;
